export const common = {
  borderRadius: "50px",
  project: {
    status: {
      inProgress: "#58d65e",
      idle: "#f1ef66",
      done: "#e683ff",
    },
  },
  spacing: {
    xs: "8px",
    s: "24px",
    m: "32px",
    l: "40px",
    xl: "56px"
  },
};
